export default __webpack_public_path__ + "scripts/resource/c6ea189eba55c6762bf7b5534fbb95be.svg";